// Serviços
import { AxiosQuotation } from "../../service/serviceBasic";
import currency from '../../helper/currency';

// Tipos
import {
    SET_VALUE_COTACAO,
    SET_PAISES_COTACAO,
    SET_RESULT_COTACAO,
    SET_FORM_COTACAO,
    SET_LOADING_COTACAO,
    SET_LIMITES_PAIS_MOEDAS,
    SET_INITIAL_STATE,
    SET_ULT_ALT_VR
} from "./types";

const setResult = (value) => ({
    type: SET_RESULT_COTACAO,
    payload: value,
});

export const setValue = (value, name) => ({
  type: SET_VALUE_COTACAO,
  payload: {value, name},
});

export const setLoading = (value) => ({
    type: SET_LOADING_COTACAO,
    payload: value,
  });

export const setPaises = (value) => ({
    type: SET_PAISES_COTACAO,
    payload: value,
});

export const setForm = (value, name) => ({
    type: SET_FORM_COTACAO,
    payload: {value, name},
})

const setLimitesPaisMOedas = value => ({
    type: SET_LIMITES_PAIS_MOEDAS,
    payload: value,
})

const setInitialState = () => ({
    type: SET_INITIAL_STATE
})

export const setUltAltVR = (flag) => ({
    type: SET_ULT_ALT_VR,
    payload: flag
})

export const init = () => dispatch => {

    dispatch(setInitialState());
    dispatch(setLoading(true));

    let filter = { TemDDI: true }
    return AxiosQuotation.post("/v1/basico/pais/list", filter)
    .then(result => {
        dispatch(setValue(result.data, "paises"))
        filter = {IdRemessadora: 1};

        return AxiosQuotation.post("/v2/remessaconta/paisenvio/listPaisMoedas", filter)
        .then(res => {          

            // Agrupar por IdMoeda 
            let array = [];
            res.data.PaisMoedas = res.data.PaisMoedas.filter(item => {
                let ifContains = false;
                ifContains = array.some(x => x.IdMoeda === item.IdMoeda);
                array = array.concat(item);
                return !ifContains;
            })
           
            //Adicionar Identificador
            let arrayPaisMoedas = res.data.PaisMoedas.map((item, index) => {
                item.Id = index;               
                return item;
            })

            var obj = {
                arrayPaisMoedas,
                limites: res.data.Limites,
                tarifa: res.data.Tarifa,
                taxasCambio: res.data.TaxasCambio,
                motivos: res.data.Motivos
            }  
            dispatch(setLimitesPaisMOedas(obj));              
            dispatch(cotar("valorEnvia"));
        })
        .catch((error) => {  
            dispatch(setValue(error.type !== undefined && error.type.includes("TWCoreWarning") ? error.message : "Ocorreu um erro.", "textWarning"));
        })
        .finally(() => {  
            dispatch(setLoading(false));
        })
    })
    .catch((error) => {         
        dispatch(setValue(error.type !== undefined && error.type.includes("TWCoreWarning") ? error.message : "Ocorreu um erro.", "textWarning"));
        dispatch(setLoading(false));
    })
}

export const cotar = (name) => (dispatch, getState) => {

    const { cotacaoReducer } = getState();
    const {form} = cotacaoReducer;

    const request = {
        ValorEnviado: name === "valorEnvia" ? currency(form.valorEnvia.replace(",","."), "en-US", false) : null,
        ValorReceber: name === "valorRecebe" ? currency(form.valorRecebe.replace(",","."), "en-US", false) : null,
        IdMotivo: 1,
        IdMoeda: form.paisRecebe.IdMoeda,
        IdRemessadora: 1,
        IdPais: form.paisRecebe.IdPais,
        PermiteEnvioProprio: false
    }

    return AxiosQuotation.post("/v1/remessa/Simulacao/solicitarCotacaoSite", request)
    .then(res => {
        dispatch(setResult(res.data));
        dispatch(setForm(currency(res.data.ValorEnviadoMoedaBase, "en-US", false), "valorEnvia"));
        dispatch(setForm(currency(res.data.ValorReceberLiquidoDestino, "en-US", false), "valorRecebe"));
    })
    .catch(error => {
        dispatch(setValue(error.type !== undefined && error.type.includes("TWCoreWarning") ? error.message : "Ocorreu um erro.", "textWarning"));
    })
    .finally(() => {
    }) 
}